<template>
    <modal :modal-id="modalId"
           :title="modalTitle"
           :preloader="preloader"
            class="notification-modal"
            @submit="submit"
            @close-modal="closeModal">

        <template slot="body">

            <div class="box">
                <div class="col-sm-12 col-md-10 pl-0 float-left mb-5">
                    <app-overlay-loader v-if="preloader"/>

                    <h2 v-if="this.inputs.status == 3 && createdUsersOptions.length === 0" class="mb-5">
                        {{ $t('invite_employee') }} {{ inputs.name }} {{ $t('so_he_can_open') }}<br> {{ $t('onboarding_landing_page') }}
                    </h2>
                    <h2 v-else-if="this.inputs.status == 3 && createdUsersOptions.length !== 0" class="mb-5">
                        {{ $t('change_employment_date_for') }} {{ inputs.name }}
                    </h2>
                    <h2 v-else class="mb-5">
                        {{ $t('invite_candidate') }} {{ inputs.name }}<br> {{ $t('to_an_interview') }}
                    </h2>

                    <div v-if="this.tenant == 'studioreaktor'">
                        <div class="mb-4 tab-comment-data"> 
                            <app-mailbox-add-form :table-id="tableMailboxId" :action="'schedule'" :candidate-id="this.inputs.id" :candidate-name="this.inputs.name+' '+this.inputs.surname" :candidate-mail="this.inputs.email" :subject="this.mailboxOptions.total > 0 ? mailboxOptions.data[0].subject : 'Nová zpráva pro uchazeče o zaměstnání'" :user-name="user.loggedInUser.full_name" :user-photo="user.loggedInUser.img" class="loading-hidden" @changed="getMailbox()"></app-mailbox-add-form>
                            <app-mailbox v-if="mailboxLoaded" :table-id="tableMailboxId" :mailbox-messages="this.mailboxOptions" class="loading-hidden"></app-mailbox>
                        </div>
                    </div>

                    <form v-if="this.tenant != 'studioreaktor'" :data-url='inputs.id ? `admin/app/candidates/${inputs.id}` : `admin/app/candidates`'
                          class="mb-2"
                          :class="{'loading-opacity': preloader}"
                          ref="form">

                      <div class="form-group row align-items-center mb-4">
                          <label v-if="this.inputs.status == 3" for="event_date" class="col-sm-12 mb-2">
                              {{ $t('start_of_employment') }}
                          </label>
                          <label v-else for="event_date" class="col-sm-12 mb-2">
                              {{ $t('interview_date') }}
                          </label>
                          <app-input id="event_date"
                                     class="col-sm-6"
                                     type="date"
                                     dateMode="dateTime"
                                     v-model="inputs.event_date"
                                     :placeholder="$t('select_valid_date')"
                                     :required="true"/>
                        <div v-if="this.noteDate" class="col-sm-12 mt-1">
                            <span class="text-danger validation-error">
                                {{ $t('please_fill_all_required_fields') }}
                            </span>
                        </div>

                      </div>

                      <div class="form-group row align-items-center mt-4 mb-2 col-md-4 pl-0 pr-0 float-left">
                          <label for="inputs_status" class="col-sm-12 mb-2 pr-5" >
                              {{ $t('send_mail_with_invitation') }} <div class="cursor-help d-inline-block" @click.prevent="isNoteCalendarHidden = !isNoteCalendarHidden"><app-icon :name="'help-circle'" width="18" height="18"/></div>
                          </label>
                          <app-input  id="checkbox_calendar"
                                      class="col-sm-6"
                                      type="checkbox"
                                      :list="calendarSelection"
                                      v-model="inputs.sendMail"
                                      />

                      </div>

                      <div v-if="this.inputs.status == 2 && this.inputs.sendMail == 1" class="form-group row align-items-center mt-4 mb-2 col-md-4 pl-0 pr-0 float-left">
                          <label for="inputs_status" class="col-sm-12 mb-2" >
                              {{ $t('select_persones_receving_invitation') }}
                          </label>
                          <app-input  id="checkbox_notification"
                                      class="col-sm-10 checkbox-row"
                                      type="checkbox"
                                      :list="notificationSelection"
                                      v-model="inputs.notification"
                                      />
                          <div v-if="this.inputs.notification.includes('2')" class="w-100">
                              <app-input id="inputs_additionalmailto"
                                         class="col-sm-12 mt-2 mb-3"
                                         type="text"
                                         v-model="inputs.additionalmailto"
                                         :placeholder="$t('multiple_emails_type_input')"/>


                          </div>
                      </div>
                      <div v-if="!isNoteCalendarHidden" class="note note-info row ml-1 mt-3 p-4 col-sm-12 col-md-4 mb-3">

                          <div class="col-md-1">
                              <app-icon :name="'calendar'" width="30" height="30"/>
                          </div>
                          <div class="col-md-10">
                              Pošle v příloze e-mailu soubor, polepáním lze termín <span v-if="this.inputs.status == 2"> pohovoru</span><span v-else-if="this.inputs.status == 3"> nástupu do zaměstnání</span> přidat do kalendářů Microsoft Outlook, Apple Calendar a další. Součástí je i odkaz na přidání události do Google kalendáře.
                          </div>

                      </div>

                      <div v-if="this.inputs.event_date && this.inputs.status == 2" class="form-group row align-items-center mt-5 mb-2">
                          <label for="inputs_status" class="col-sm-12 mb-2" >
                              {{ $t('add_google_meet_google_calendar') }}
                          </label>
                          <app-input  id="checkbox_video"
                                      class="col-sm-6"
                                      type="checkbox"
                                      :list="videoSelection"
                                      v-model="googleMeet"
                                      />
                      </div>

                      <div v-if="this.inputs.sendMail == 1" class="row col-md-12 justify-content-between half-width-container pr-0 mt-0 mb-2">
                          <div class="form-group row align-items-center md-half-width mt-3">
                              <label for="inputs_subject" class="col-sm-12 mt-0 mb-2">
                                  {{ $t('subject') }}
                              </label>
                              <app-input id="inputs_subject"
                                         class="col-sm-12"
                                         type="text"
                                         v-model="inputs.subject"
                                         />
                          </div>
                          <div class="form-group row align-items-center md-half-width">
                              <label for="inputs_title" class="col-10 mt-3 mb-2 pl-0">
                                  {{ $t('choose_from_template') }}
                              </label>
                              <a href="/mail-templates" target="_blank" class="col-2 mt-1 text-right text-muted" :title="$t('edit_templates')">
                                  <app-icon :name="'edit'" width="18" height="18"/>
                              </a>

                              <app-input id="inputs_template"
                                         class="pr-0 w-100 pr-md-2"
                                         type="select"
                                         v-model="template"
                                         :list="templateOptions"/>
                          </div>
                      </div>
                      <div v-if="this.inputs.sendMail == 1" class="form-group row align-items-center">
                          <app-overlay-loader v-if="preloader"/>

                          <app-overlay-loader v-if="editorPreloader"/>
                          <app-input id="inputs_message"
                                     class="col-sm-12"
                                     type="text-editor"
                                     v-model="inputs.message"
                                     :placeholder="$t('text_type_input')"/>
                        <app-input v-if="editorPreloader"
                                                            id="inputs_text_blind"
                                                            class="col-sm-12"
                                                            :class="{'loading-opacity': editorPreloader}"
                                                            type="textarea"/>

                        <div v-if="this.note" class="col-sm-12 mt-1">
                            <span class="text-danger validation-error">
                                {{ $t('please_fill_all_required_fields') }}
                            </span>
                        </div>

                      </div>
                    </form>

                    <div v-if="createdUsersOptions.length === 0 && inputs.status == 3" :class="{'loading-opacity': preloader}">
                        <div class="form-group row align-items-center md-half-width mt-3">
                            <label for="inputs_subject" class="col-sm-12 mt-0 mb-2">
                                Vytvořit účet v jazyce
                            </label>
                        <app-input id="newUser_lang"
                                   class="col-sm-6"
                                   type="select"
                                   v-model="newUser.lang"
                                   :list="langOptions"
                                   :placeholder="$t('default_language')"
                                   :required="true"/>
                        </div>
                    </div>

                    <div v-if="createdUsersOptions.length === 0 && inputs.status == 3" class="note note-info w-100 mt-2 mb-3 p-4 float-left">
                        <app-icon :name="'key'" width="19" height="19" class="mt-0 mr-2"/>
                        <strong>Přístupové údaje vytvoříme a zašleme automaticky po odeslání této pozvánky</strong>

                    </div>
                    <div v-else-if="createdUsersOptions.length !== 0 && inputs.status == 3" class="note note-info w-100 mt-2 mb-3 p-4 float-left">
                        <app-icon :name="'key'" width="19" height="19" class="mt-0 mr-2"/>
                        <strong>Uživatel již obdržel své přístupové údaje na e-mail {{ this.createdUsersOptions[0].email }}  </strong> Stačí se tak např. ozvat že potvrzujete upravený datum nástupu

                    </div>



                </div>
                <div class="col-sm-12 col-md-2 mt-5 float-left text-center">
                    <img src="/images/illustration_done.svg" style="width: 100%;min-width: 200px;">
                </div>


            </div>



            <div class="clearfix mb-5"></div>

        </template>
    </modal>
</template>

<script>
    import {FormMixin} from '../../../../../../core/mixins/form/FormMixin.js';
    import {ModalMixin} from "../../../../../Mixins/ModalMixin";
    import {UserMixin} from "../../../../../../app/Components/Views/Auth/Mixins/UserMixin";
    import AppLibrary from "../../../../../Helpers/AppLibrary";

    export default {
        name: "ScheduleModal",
        extends: AppLibrary,
        mixins: [FormMixin, ModalMixin, UserMixin],
        props: {
            tableId: String,
            selectedRows: Array,
            timelineStates: Array,
            jobOptions: Array,
            modalType: String,
        },
        data() {
            return {
                preloader: false,
                editorPreloader: false,
                finishedGetData: false,
                note: false,
                noteDate: false,
                isNoteCalendarHidden: true,
                template: 0,
                templateOptions: [
                    {id: 0, value: this.$t('select'),},
                ],
                createdUsersOptions: [],
                langOptions: [
                    {id: 'cs', value: "Čeština",},
                    {id: 'en', value: "English",},
                    {id: 'sk', value: "Slovenčina",},
                ],
                mailboxOptions: [],
                tenant: "",

                inputs: {
                    name: '',
                    event_type: 'schedule',
                    event_date: '',
                    timeline_state: '',
                    mailto: '',
                    replyto: '',
                    additionalmailto: '',
                    subject: '',
                    title: '',
                    description: '',
                    dateStop: '',
                    urlAddress: '',
                    status: '',
                    id: '',
                    job: '',
                    notification: ["1"],
                    notification_me: ["1"],
                    talentpool: ["1"],
                    template: ["1"],
                    sendMail: ["1"],
                    myCalendar: ["2"],
                    video: [],
                    message: '',
                },

                newUser: {
                    email: '',
                    candidate_id: '',
                    lang: 'cs',
                    roles: [5]
                },

                googleMeet: [],

                calendarSelection: [
                    {id: '1', value: this.$t('yes')},
                ],

                inviteSelection: [
                    {id: '1', value: this.$t('yes')},
                ],

                myCalendarSelection: [
                    {id: '1', value: this.$t('google_calendar')},
                    {id: '2', value: this.$t('other_calendars')},
                ],
                videoSelection: [
                    {id: '1', value: 'Ano'},
                ],
                notificationSelection: [
                    {id: '1', value: this.$t('to_employee')},
                    {id: '2', value: this.$t('to_others')},
                ],
                notificationSelectionMe: [
                    {id: '1', value: this.$t('to_me')},
                ],

                modalId: 'schedule-Modal',
                modalTitle: this.$t('add'),
                value: {},
            }
        },
        watch: {
          googleMeet: {
            sync: true,
            handler (val, oldVal) {
                if(val != 0){
                    let left = (screen.width/2)-(1080/2);
                    let top = (screen.height/2)-(420/2);
                    let googleSubject = '';

                    if(this.inputs.status == 3){
                        googleSubject = 'Nástup do zaměstnání - '+this.inputs.name;
                    } else {
                        googleSubject = this.timelineStates[this.inputs.timeline_state-1].value+' - '+this.inputs.name;
                    }

                    window.open("https://calendar.google.com/calendar/u/0/r/eventedit?text="+googleSubject+"&dates="+moment(this.inputs.event_date).format('YYYYMMDD')+"T"+moment(this.inputs.event_date).format('HHmmss')+"/"+moment(this.inputs.event_date).add(60, 'minutes').format('YYYYMMDD')+"T"+moment(this.inputs.event_date).add(60, 'minutes').format('HHmmss')+"&ctz=Europe%2FPrague&details="+this.inputs.message+"&add="+this.inputs.email+","+this.inputs.additionalmailto+"&calendar-label=Pohovor","Přidat Google Meet","menubar=0,resizable=0,width=1080,height=420,top="+top+",left="+left+" ");

                }
            }
        },
        template: {
          sync: true,
          handler (val, oldVal) {
              if(val != 0){
                  this.getTemplateData();
              }
          }
        },

        },

        created() {
            if (this.selectedCandidates) {
                this.preloader = true;
            }

            // Display available job templates
            let url = 'admin/app/templates?filter_with_status_id=1&per_page=500';
            this.axiosGet(url).then(response => {

                const templateOptionsArray = response.data.data.map(({
                  name: value,
                  ...rest
                }) => ({
                  value,
                  ...rest
                }));

                this.templateOptions = templateOptionsArray;
                this.templateOptions.unshift({"id": 0, "value": this.$t('select')});

            }).catch(({response}) => {
            }).finally(() => {

                this.finishedGetData = true;

            });

        },
        mounted() {
            let candidateDetails = this.selectedRows.map(candidateDetails => {
                return candidateDetails.fullname;
            });
            this.inputs.name = Object.values(candidateDetails).join(", ");

            candidateDetails = this.selectedRows.map(candidateDetails => {
                return candidateDetails.email;
            });
            this.inputs.email = Object.values(candidateDetails).join(",");
            this.newUser.email = this.inputs.email;

            candidateDetails = this.selectedRows.map(candidateDetails => {
                return candidateDetails.id;
            });
            this.inputs.id = Object.values(candidateDetails).join(",");
            this.newUser.candidate_id = this.inputs.id;
            this.getUserIdByCandidate();

            candidateDetails = this.selectedRows.map(candidateDetails => {
                return candidateDetails.phone;
            });
            this.inputs.phone = Object.values(candidateDetails).join(",");

            candidateDetails = this.selectedRows.map(candidateDetails => {
                return candidateDetails.job;
            });
            this.inputs.job = Object.values(candidateDetails).join(",");

            candidateDetails = this.selectedRows.map(candidateDetails => {
                return candidateDetails.timeline_state;
            });
            this.inputs.timeline_state = Object.values(candidateDetails).join(",");

            candidateDetails = this.selectedRows.map(candidateDetails => {
                return candidateDetails.status;
            });
            this.inputs.status = parseInt(candidateDetails);

            if (this.inputs.event_date){
                this.inputs.event_date = this.getDateFormatForBackend(this.inputs.event_date);
            }

            let photo = '';
            if(this.user.loggedInUser.img){
                photo = '<td style="width: 100px"><img src="'+window.location.origin+this.user.loggedInUser.img+'" alt="User profile photo" height="60"></td>';
            }
            let messageSuffix = 'S pozdravem <br><table align="left"><tbody><tr>'+photo+'<td><b>'+this.user.loggedInUser.full_name+'</b><br>'+this.user.loggedInUser.roles[0].name+'<br>'+this.user.loggedInUser.email+'</td></tr></tbody></table><br><br><br>';

            if(this.inputs.status == 3){
                this.inputs.message = 'Doplňte text zprávy... <br><br><b>Naše doporučení:</b><br>– přivítejte zaměstnance do firmy<br>– uveďte místo, datum a čas nástupu<br>– pozvěte ho aby se přihlásil do svého účtu, najde tu informace jak budou probíhat první dny v zaměstnání a přehled nad úkoly a kurzy <br><br>'+messageSuffix;
            } else {
                this.inputs.message = 'Doplňte text zprávy...<br><br>'+messageSuffix;
            }

            this.inputs.replyto = this.user.loggedInUser.email;

            this.getTenantSettings();
            this.getMailbox();
            this.preloader = false;

        },
        methods: {
            /**
             * Actions
             * */

            setFormData() {

            },
            beforeSubmit() {

            },
            submit() {
                // Actions after submit
                this.changeTimelineState();

                if(this.inputs.status == 3 && this.createdUsersOptions.length === 0 && ((this.inputs.sendMail == 0 && this.inputs.event_date) || (this.inputs.sendMail == 1 && this.inputs.event_date && this.inputs.subject))){
                    // If all filled and user not already created, create one, wait for response, send notification and close modal in the end
                    this.createUserAccount();
                } else {
                    // If not creating user, send notification and close modal right now
                    this.prepareNotification();
                }

            },
            changeTimelineState() {
                // Change timeline_state based on given employment date
                if(this.inputs.status == 3){
                    console.log("changeTimelineState");
                    this.setTimelineState();
                }
            },
            setTimelineState() {
                let todayDate = moment().startOf('day');
                let eventDate = moment(this.inputs.event_date).startOf('day');
                let eventDateEnd = "";
                let differenceInDays = moment.duration(todayDate.diff(eventDate)).asDays();
                let timelineStateStart = "";
                let timelineStatePeriod = "";
                let correctTimelineState = "";
                let preboardingState = this.timelineStates.findIndex(t => t.id === 7);
                let employmentTrialPeriodState = this.timelineStates.findIndex(t => t.start === "1d");
                let employmentStartState = this.timelineStates.findIndex(t => t.start === "0d");

                

                if(moment(todayDate).isAfter(eventDate)){
                    // Onboarding

                    let todayDate_formatted = "";
                    let eventDate_formatted = "";
                    let eventDateEnd_formatted = "";

                    for (var i = 0; i < this.timelineStates.length; i++) {
                        timelineStateStart = this.timelineStates[i].start;

                        if(timelineStateStart != "0d" && !timelineStateStart.includes("-")){

                            if(timelineStateStart.includes("y")){
                                timelineStatePeriod = "years";
                            } else if(timelineStateStart.includes("m")){
                                timelineStatePeriod = "months";
                            } else {
                                timelineStatePeriod = "days";
                            }

                            timelineStateStart = timelineStateStart.replace(/[^0-9\.]+/g, "");
                            eventDate = moment(this.inputs.event_date).startOf('day');
                            eventDateEnd = moment(this.inputs.event_date).startOf('day').add(timelineStateStart, timelineStatePeriod);

                            todayDate_formatted = moment().startOf('day').format('YYYY-MM-DD HH:mm');
                            eventDate_formatted = moment(this.inputs.event_date).startOf('day').format('YYYY-MM-DD HH:mm');
                            eventDateEnd_formatted = moment(this.inputs.event_date).startOf('day').add(timelineStateStart, timelineStatePeriod).format('YYYY-MM-DD HH:mm');

                            console.log("hledám v "+this.timelineStates[i].value);
                            console.log("dnes "+todayDate_formatted+", zacatek "+eventDate_formatted+", konec: "+eventDateEnd_formatted);

                            if(moment(eventDateEnd).isAfter(todayDate) || moment(eventDateEnd).isSame(todayDate)){
                                console.log("odpovídá "+this.timelineStates[i].value);
                                console.log("dnes "+todayDate_formatted+", zacatek "+eventDate_formatted+", konec: "+eventDateEnd_formatted);
                                correctTimelineState = this.timelineStates[i];
                                break;
                            }
                        }
                    }

                } else if (differenceInDays == 0){
                    // Employement Start
                    correctTimelineState = this.timelineStates[employmentStartState];

                } else {
                    // Preboarding
                    correctTimelineState = this.timelineStates[preboardingState];

                }

                if(correctTimelineState.id){
                    this.inputs.timeline_state = correctTimelineState.id;
                    console.log("correct id "+correctTimelineState.id);
                }

            },
            createUserAccount() {
                this.preloader = true;

                this.axiosPost({
                    url: '/admin/auth/users/invite-user',
                    data: this.newUser
                }).then(response => {
                    console.log(response.data.message);
                    if (response.data) {
                        this.$toastr.s(this.$t(response.data.message));
                    } else {
                        this.$toastr.s(this.$t(response.data.message));
                    }

                }).finally(() => {
                    // If user created continue and send notification and close modal afterwards
                    this.prepareNotification();
                });
            },
            prepareNotification() {
                if(this.inputs.event_date && this.inputs.message && this.inputs.subject && this.inputs.sendMail == 1){
                    this.generateCalendar();
                    this.preloader = true;

                    // Parse date and time fields to event_date
                    this.inputs.event_date = moment(this.inputs.event_date).format('YYYY-MM-DD HH:mm');
                    this.sendAppNotifications();


                    // @todo: after enabling Amazon SES, enable sending directly to candidate
                    // this.inputs.mailto = [this.user.loggedInUser.email, this.inputs.email, this.inputs.additionalmailto];
                    let mailTo = [this.user.loggedInUser.email, this.inputs.additionalmailto];
                    console.log(this.inputs);

                    // Always send to me (because of calendar)
                    if(this.user.loggedInUser.email){
                        this.sendMailNotifications(this.inputs.email, this.user.loggedInUser.email);
                    }

                    // Send to others (delay because of proper mail sending)
                    let _this = this;
                    // use foreach for rejection and send mails separetly
                    let mailTos = this.inputs.additionalmailto;
                    if(this.inputs.additionalmailto){
                        setTimeout(function(){ _this.sendMailNotifications("",mailTos); }, 10);
                    }

                } else if (this.inputs.event_date && this.inputs.sendMail != 1){
                    this.generateCalendar();
                    this.preloader = true;

                    // Parse date and time fields to event_date
                    this.inputs.event_date = moment(this.inputs.event_date).format('YYYY-MM-DD HH:mm');
                    this.sendAppNotifications();

                } else {
                    this.note = true;
                    this.noteDate = true;

                }
            },
            sendAppNotifications() {
                // Push predefined automatic in-app notification and/or e-mail
                this.axiosPatch({
                    url: 'admin/app/candidates-app-notifications',
                    data: this.inputs
                }).then(response => {

                    if (response.data) {
                        this.afterSuccess(response);
                    } else {
                        this.afterError(response);
                    }

                }).finally(() => {
                    if(this.inputs.sendMail != 1){
                        this.preloader = false;
                        $(".floating-bar-fixed-bottom").addClass("animate__fadeOut").delay(100).fadeOut();
                        setTimeout(function(){ $("#schedule-Modal").modal('hide'); }, 10);

                        this.$hub.$emit('reload-' + this.tableId);

                        // Animate badge notification
                        let notifyBadge = this.inputs.timeline_state-1;
                        setTimeout(function(){ $('.timeline .state:eq('+notifyBadge+')').addClass('notify');}, 1000);
                        setTimeout(function(){ $('.timeline .state:eq('+notifyBadge+')').removeClass('notify'); }, 2000);
                    }

                });
            },
            sendMailNotifications(inviteeEmail, creatorEmail) {
                // Send personalized e-mail to unique set of receipents

                if(inviteeEmail && inviteeEmail != "" && this.inputs.notification.includes("1")){
                    this.inputs.mailto = inviteeEmail;
                    this.inputs.mailcc = creatorEmail;
                } else {
                    this.inputs.mailto = creatorEmail;
                    this.inputs.mailcc = "";
                }
                this.inputs.mailfrom = this.user.loggedInUser.email;
                console.log('mailto: '+this.inputs.mailto);
                console.log('sendMailNotifications: '+this.inputs.description+this.inputs.urlAddress);


                this.axiosPatch({
                    url: 'admin/app/candidates-mail-notifications',
                    data: this.inputs
                }).then(response => {

                    if (response.data) {
                        this.afterSuccess(response);
                    } else {
                        this.afterError(response);
                    }

                }).finally(() => {
                    this.preloader = false;
                    $(".floating-bar-fixed-bottom").addClass("animate__fadeOut").delay(100).fadeOut();
                    setTimeout(function(){ $("#schedule-Modal").modal('hide'); }, 10);
                    this.$hub.$emit('reload-' + this.tableId);

                    // Animate badge notification
                    // 7000ms delay due to sendMailNotifications() beeing initiated for each e-mail address
                    let notifyBadge = this.inputs.timeline_state-1;
                    setTimeout(function(){ $('.timeline .state:eq('+notifyBadge+')').addClass('notify');}, 1000);
                    setTimeout(function(){ $('.timeline .state:eq('+notifyBadge+')').removeClass('notify'); }, 7000);

                });
            },
            generateCalendar() {
                let language = 'cs';
                let subject = '';
                let urlAddress = '';
                let jobOptions = this.jobOptions;
                let jobId = parseInt(this.inputs.job);
                let job = jobOptions.filter(obj => {
                    return obj.id === jobId
                });

                let description = 'Telefon: '+this.inputs.phone+', pracovní pozice: '+job[0].value;

                if(this.inputs.status == 3){
                    subject = 'Nástup do zaměstnání - '+this.inputs.name;
                    urlAddress = 'https://onboardio.pro/onboarding?profile='+this.inputs.id;
                } else {
                    subject = this.timelineStates[this.inputs.timeline_state-1].value+' - '+this.inputs.name;
                    urlAddress = 'https://onboardio.pro/hiring?profile='+this.inputs.id;
                }

                let begin = this.inputs.event_date;
                let stop = moment(this.inputs.event_date).add(1, 'hours');
                let location = '';
                let urlGoogleMeet = '';
                if(this.inputs.event_location && this.inputs.event_location.indexOf('http') !== -1){
                    urlAddress = '';
                    // @todo
                } else {
                    location = '';
                }

                // Data for notify()
                this.inputs.title = subject;
                this.inputs.description = description;
                this.inputs.dateStop = stop;
                this.inputs.urlAddress = urlAddress;
                console.log(this.inputs);

                let organizer = this.user.loggedInUser.full_name;
                this.$ics.addEvent(language, subject, description, location, begin, stop, urlAddress, organizer);
                let fileName = subject;
                this.$ics.download(fileName);


            },
            getMailbox() {
                if((this.tenant == "studioreaktor") && (this.inputs.email || this.inputs.mailto)){
                    let url = "admin/app/mailbox", 
                        reqData = {};

                    reqData.params = {
                        from: this.inputs.email ? this.inputs.email : this.inputs.mailto,
                    };

                    this.axiosGet(url, reqData)
                        .then((response) => {
                            this.mailboxOptions = response.data;
                            this.mailboxLoaded = true;
                        })
                        .catch(({ response }) => {})
                        .finally(() => {});
                }
            },
            afterSuccess(response) {
                this.$toastr.s(this.$t(response.data));

            },
            afterError(response) {
                this.$toastr.s(this.$t(response.data));

            },
            clear() {
                this.inputs = {};
            },


            /**
             * Get additional data
             */
             getUserIdByCandidate() {
                 // Check if user account already exists
                 this.axiosGet('user-id?candidate_id='+this.inputs.id).then(response => {

                     this.createdUsersOptions = response.data;

                 }).catch(({response}) => {
                 }).finally(() => {
                 });
             },


            /**
             * Fill from Template
             */
            getTemplateData() {
                let photo = '';
                if(this.user.loggedInUser.img){
                    photo = '<td style="width: 100px"><img src="'+this.user.loggedInUser.img+'" alt="User profile photo" height="60"></td>';
                }
                let messageSuffix = '<table align="left"><tbody><tr>'+photo+'<td><b>'+this.user.loggedInUser.full_name+'</b><br>'+this.user.loggedInUser.roles[0].name+'<br>'+this.user.loggedInUser.email+'</td></tr></tbody></table><br><br><br>';

                let selectedTemplateId = parseInt(this.template);
                let templates = this.templateOptions;
                const selectedTemplate = templates.find(o => o.id === selectedTemplateId);

                this.finishedGetData = false;
                this.editorPreloader = true;
                this.inputs.subject = selectedTemplate.title;
                this.inputs.message = selectedTemplate.body+messageSuffix;

                let _this = this;
                setTimeout(function(){
                    _this.finishedGetData = true;
                    _this.editorPreloader = false;
                }, 500);
            },

            /**
             * Tenant-based modifications
             */
            getTenantSettings() {
                if (window.location.href.indexOf("localhost") > -1) {
                    this.tenant = "localhost";
                } else {
                    this.tenant = window.location.host.split(".")[0];
                }
            },


        },
    }
</script>
